import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { IsDeleteDialogComponent } from './is-delete-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class IsDeleteDialogService {

  constructor(public dialog: MatDialog) { }

  openDialog(data?: any, callBackFn?: (result: any) => void): void {
    const dialogRef = this.dialog.open(IsDeleteDialogComponent, {
      width: '680px',
      data,
      autoFocus: false,
      panelClass: 'dialog'
    });

    // called when dialog is closed
    dialogRef.afterClosed().subscribe((result) => {
      if (callBackFn) {
        callBackFn(result);
      }
    });
  }
}
